import {
	IGetComboGroupInfo,
	IGetComboItemsShort,
	IGetComboItemsShortResponse,
	ICreateComboGroup,
	IUpdateComboGroup,
	IGetPaginatedComboGroups,
	IComboGroups,
	IGetComboGroupPositionList,
	IUpdateComboGroupPositions,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetComboGroupInfo = (comboGroupID: string): Promise<IGetComboGroupInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/ComboGroups/${comboGroupID}` });
};

const serviceGetComboItemsShort = (args: IGetComboItemsShort): Promise<IGetComboItemsShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ComboItems/shortByRestaurantIds`, data: args });
};

const serviceCreateComboGroup = (data: ICreateComboGroup): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ComboGroups`, data });
};

const serviceUpdateComboGroup = (data: IUpdateComboGroup): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/ComboGroups/${data.id}`, data });
};

const serviceGetPaginatedComboGroups = (args: IGetPaginatedComboGroups): Promise<AxiosResponse<IComboGroups>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ComboGroups/filtered`, data: args });
};

const serviceDeleteComboGroup = (comboGroupID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/ComboGroups/${comboGroupID}`,
	});
};

const serviceGetComboGroupPositionList = (dishId: string): Promise<IGetComboGroupPositionList> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/ComboGroups/positionList?dishId=${dishId}` });
};

const serviceUpdateComboGroupPositions = (data: IUpdateComboGroupPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/ComboGroups/changePositions`, data });
};

export {
	serviceGetComboGroupInfo,
	serviceGetComboItemsShort,
	serviceCreateComboGroup,
	serviceUpdateComboGroup,
	serviceGetPaginatedComboGroups,
	serviceDeleteComboGroup,
	serviceGetComboGroupPositionList,
	serviceUpdateComboGroupPositions,
};
